/* eslint-disable consistent-default-export-name/default-import-match-filename */
import ServerHeaderDataCell from './server/HeaderDataCell'
import WithResize from './WithResize'
import classNames from 'classnames'
import styles from './server/elements/Table.module.css'
import { memo } from 'react'
import { useColumnWidths } from './utils/TableStore/ResizeContext'
import { useField } from './utils/TableStore'
import type { ColumnField } from './server/types'
const DataCellWithResize = WithResize(ServerHeaderDataCell)
function HeaderDataCell<T extends Record<string, unknown>>({
  field,
  firstRow,
  colIndex,
  fixed,
}: {
  field: ColumnField<T>
  firstRow: boolean
  colIndex: number
  fixed?: boolean
}) {
  const column = useField<T>(field)!
  const widths = useColumnWidths(colIndex)
  return (
    <DataCellWithResize
      {...column}
      {...widths}
      colIndex={colIndex}
      firstRow={firstRow}
      className={classNames({ [styles.fixed!]: fixed })}
    />
  )
}

export default memo(HeaderDataCell)
